import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum RejectionReason {
  UNSUPPORTED_FORMAT = 'UNSUPPORTED_FORMAT',
  FILE_SIZE_TOO_BIG = 'FILE_SIZE_TOO_BIG',
}

export interface RejectedFile {
  name: string;
  reason: RejectionReason;
}

interface FilesState {
  files: File[];
  pendingFiles: File[];
  rejectedFiles: RejectedFile[];
}

const initialState: FilesState = {
  files: [],
  pendingFiles: [],
  rejectedFiles: [],
};

export const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    registerFiles: (state, action: PayloadAction<File[]>) => {},
    setFiles: (state, action: PayloadAction<File[]>) => {
      state.files = action.payload;
    },
    addFiles: (state, action: PayloadAction<File[]>) => {
      state.files = [...state.files, ...action.payload];
    },
    removeFiles: (state, action: PayloadAction<string[]>) => {
      // Remove files by file names (from thumbnail selection)
      const fileNamesToRemove = new Set(action.payload);
      state.files = state.files.filter(f => !fileNamesToRemove.has(f.name));
    },
    clearFiles: (state) => {
      return initialState;
    },
    addPendingFiles: (state, action: PayloadAction<File[]>) => {
      state.pendingFiles = [...state.pendingFiles, ...action.payload];
    },
    addRejectedFiles: (state, action: PayloadAction<RejectedFile[]>) => {
      state.rejectedFiles = [...state.rejectedFiles, ...action.payload];
    },
    clearValidation: (state) => {
      state.pendingFiles = [];
      state.rejectedFiles = [];
    },
    confirmPendingFiles: (state) => {
      state.files = [...state.files, ...state.pendingFiles];
      state.pendingFiles = [];
      state.rejectedFiles = [];
    },
  },
});

export const { 
  registerFiles,
  setFiles, 
  addFiles, 
  removeFiles, 
  clearFiles,
  addPendingFiles,
  addRejectedFiles,
  clearValidation,
  confirmPendingFiles,
} = filesSlice.actions;
export default filesSlice.reducer;
